document.addEventListener("DOMContentLoaded", () => {
  //drawer-search
  var search_carousel = document.querySelector('.active-header .search-recommendations .grid');
  var search_flkty_prev = document.querySelector('.active-header .sr_flickity-prev');
  var search_flkty_next = document.querySelector('.active-header .sr_flickity-next');
  var search_input = document.querySelector('.active-header .site-header__search-form .site-header__search-input');

  var search_flkty = new Flickity( search_carousel, {
    prevNextButtons: false,
    wrapAround: true,
    pageDots: false,
    accessibility: true,
    autoPlay: false,
    percentPosition: false,
    cellAlign: "left",
    contain: true,
    lazyLoad: true,
    draggable: true,
    groupCells: true,
    resize: true,
    ImagesLoaded: true
  });

  search_flkty_prev.addEventListener("click", function () {
    search_flkty.previous();
  });
  search_flkty_next.addEventListener("click", function () {
    search_flkty.next();
  });

  search_input.addEventListener("keyup", (event) => {
    setTimeout(() => {
      search_flkty.resize();
    }, 1000);
  });

  const buttonClose = document.querySelectorAll('.active-header .drawer__close-button');
  buttonClose.forEach(btn => {
    btn.addEventListener('click', function () {
      resetMenu();
    })
  })

  function resetMenu() {
    const isOpen = document.querySelectorAll('.active-header .mobile-nav .is-open');
    const arrowButtons = document.querySelectorAll('.active-header #NavDrawer .collapsible-trigger.collapsible--auto-height');

    isOpen.forEach(item => {
      item.classList.remove('is-open');
      item.style.height = '0';
    })

    arrowButtons.forEach(btn => {
      btn.style.height = 'auto';
    })
  }
  resetMenu()

  const mobileMegaSubTriggers =  document.querySelectorAll('.active-header .mobile-mega_sub .mobile-nav__toggle .collapsible-trigger');
  const mobileMegaGrandSubTriggers = document.querySelectorAll('.active-header .mobile-mega_grand-sub .collapsible-trigger');
  const mobileDrawerClose = document.querySelector('.active-header .mobile-drawer--close');
  const drawerScrollable = document.querySelector('.active-header #NavDrawer .drawer__scrollable');
  const logo = document.querySelector('.active-header #NavDrawer .drawer__fixed-header .drawer-logos');
  const closesPopup = document.querySelectorAll('.active-header .drawer__header .drawer__close .drawer__close-button.js-drawer-close');

  // mobileMegaSubTriggers.forEach(mobileMegaSubTrigger => {
  //   mobileMegaSubTrigger.addEventListener('click', function() {

  //     logo.classList.add('hide');
  //     mobileDrawerClose.classList.add('active', 'level-1');
  //     drawerScrollable.classList.add('level-1');
  //   })
  // })

  // mobileMegaGrandSubTriggers.forEach(mobileMegaGrandSubTrigger => {
  //   mobileMegaGrandSubTrigger.addEventListener('click', function() {

  //     mobileDrawerClose.classList.remove('level-1');
  //     mobileDrawerClose.classList.add('level-2');
  //     drawerScrollable.classList.add('level-2');
  //   })
  // })

  // mobileDrawerClose.addEventListener('click', function(){
  //   if(this.classList.contains('level-2')) {
  //     const step2 = document.querySelector('.active-header .level-1.level-2 .mobile-mega_grand-sub .collapsible-trigger.is-open');

  //     step2.click();
  //     drawerScrollable.classList.remove('level-2');
  //     mobileDrawerClose.classList.remove('level-2');
  //     mobileDrawerClose.classList.add('level-1')
  //   } else {
  //     const step1 = document.querySelector('.active-header .level-1 .mobile-mega_sub .collapsible-trigger.is-open');

  //     step1.click();
  //     drawerScrollable.classList.remove('level-1');
  //     mobileDrawerClose.classList.remove('active', 'level-1');
  //     logo.classList.remove('hide');
  //   }
  // })

  closesPopup.forEach(closePopup => {
    closePopup.addEventListener('click', function() {
      logo.classList.remove('hide');
      mobileDrawerClose.classList.remove('level-1');
      mobileDrawerClose.classList.remove('level-2');
      mobileDrawerClose.classList.remove('active');
      drawerScrollable.classList.remove('level-1');
      drawerScrollable.classList.remove('level-2');
    })
  })
})
function updateDrawerCountsFromDOM() {
  let totalCount = 0;

  document.querySelectorAll('.cart__item .js-qty__num').forEach(input => {
    const qty = parseInt(input.value, 10);
    if (!isNaN(qty)) {
      totalCount += qty;
    }
  });

  const formattedCount = `${totalCount} item${totalCount !== 1 ? 's' : ''}`;

  document.querySelectorAll('.drawer__count').forEach(el => {
    el.textContent = formattedCount;
  });
}
function handleOpenCartDrawer() {
  

  const youMyAlsoLike = document.querySelector('.active-header .cart-drawer-upsell');
  if (!youMyAlsoLike) return;

  const title = youMyAlsoLike.querySelector('.header-part');
  const productPart = youMyAlsoLike.querySelector('.product-part');

  if (!title || !productPart || productPart.dataset.event) return;

  if (window.innerWidth > 768) {
    productPart.classList.add('hidden');
    productPart.dataset.event = 'open';

    const closeBtn = document.createElement('span');
    closeBtn.textContent = 'open';
    closeBtn.classList.add('close');
    title.append(closeBtn);

    closeBtn.addEventListener('click', function () {
      if (productPart.dataset.event === 'close') {
        cartEvent(this, productPart, 'open');
      } else if (productPart.dataset.event === 'open') {
        cartEvent(this, productPart, 'close');
      }
    });
    
    updateDrawerCountsFromDOM();
    setTimeout(function(){
      updateDrawerCountsFromDOM();
    },500);
  }

  function cartEvent(btn, productBlock, state) {
    btn.textContent = state;
    productBlock.dataset.event = state;

    if (state === 'open') {
      productBlock.classList.add('hidden');
    } else if (state === 'close') {
      productBlock.classList.remove('hidden');
    }
  }
}


document.addEventListener('drawerOpen.CartDrawer', handleOpenCartDrawer)
